import CreateAuthor from "../create";
import {useEffect, useState} from "react";
import axios from "axios";
import {useParams} from "react-router-dom";

export default function UpdateAuthor() {
    const params = useParams()
    const id = params.id
    const [author, setAuthor] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        async function getData() {
            const authorResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/authors/${id}`)
            setAuthor(authorResponse.data)
            setLoading(false);
        }
        getData()
    }, [])

    if (loading) {
        return (<> </>)
    }

    return(
        <CreateAuthor update author={author}/>
    )
}
